/**
 * Utility functions for device navigation
 */

/**
 * Opens the device's default navigation app with the given address
 * @param address - The address to navigate to
 */
export const openDeviceNavigation = (address: string) => {
  const query = encodeURIComponent(address);
  
  // Check if we're on a mobile device
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if (isMobile) {
    // Try to open native apps first
    const iosUrl = `maps://?q=${query}`;
    const androidUrl = `geo:0,0?q=${query}`;
    
    // For iOS devices
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      window.location.href = iosUrl;
      return;
    }
    
    // For Android devices
    if (/Android/.test(navigator.userAgent)) {
      window.location.href = androidUrl;
      return;
    }
  }
  
  // Fallback to web maps (will open in default browser maps app on mobile)
  const webUrl = `https://maps.google.com/maps?q=${query}`;
  window.open(webUrl, '_blank');
};

/**
 * Opens navigation for a specific street address
 * @param street - Street name
 * @param plz - Postal code
 */
export const openNavigationForStreet = (street: string, plz: string) => {
  const address = `${street}, ${plz}`;
  openDeviceNavigation(address);
};

/**
 * Opens navigation for a full address including house number
 * @param street - Street name
 * @param houseNumber - House number
 * @param plz - Postal code
 */
export const openNavigationForAddress = (street: string, houseNumber: string, plz: string) => {
  const address = `${street} ${houseNumber}, ${plz}`;
  openDeviceNavigation(address);
};

/**
 * Opens navigation for an area (general location)
 * @param areaName - Area/city name
 * @param plz - Postal code
 */
export const openNavigationForArea = (areaName: string, plz: string) => {
  const address = `${plz} ${areaName}`;
  openDeviceNavigation(address);
};